/**
 * Browser storage keys used by authentication flows.
 * HttpOnly cookies (WorkOS session) are not readable from JS — not listed here.
 *
 * @see docs/components/sso/AUTH_FLOWS_AND_STORAGE.md
 */
export const AUTH_STORAGE_KEYS = {
  /** Bearer login: JWT + user snapshot */
  AUTH_DATA: "auth_data",
  /** Cached SSO user profile (API shape); not the source of truth for HttpOnly session */
  WORKOS_USER: "workos_user",
  /** Admin flag cache */
  IS_ANI_ADMIN: "isAniAdmin",
  /** Post-logout: suppress cookie-based SSO restore until TTL or explicit login */
  SESSION_IGNORE_COOKIE_UNTIL: "ani_session_ignore_cookie_until",
} as const;

export type AuthStorageKey =
  (typeof AUTH_STORAGE_KEYS)[keyof typeof AUTH_STORAGE_KEYS];
